import API from '../api/apiConfig';

/**
 * Handles the "Buy Now" deep-linking flow.
 * Proxies the request through our local API to generate an affiliate link
 * and opens it in a new browser tab.
 */
export const buyNowProduct = async (sid, pid) => {
  if (!sid || !pid) {
    console.error('Missing sid or pid for redirection');
    return;
  }

  try {
    console.log(`Generating deeplink for sid: ${sid}, pid: ${pid}`);

    const response = await API.post(`/api/buy-now`, {
      sid: Number(sid),
      pid: pid
    });

    if (response.data && (response.data.data || response.data.url)) {
      let redirectUrl = response.data.data || response.data.url;
      
      // Append or replace the affiliate tag: tbde012-21
      const affiliateTag = "tbde012-21";
      if (redirectUrl.includes("tag=")) {
        // Replace existing tag if any
        redirectUrl = redirectUrl.replace(/tag=[^&]*/, `tag=${affiliateTag}`);
      } else {
        // Append new tag
        redirectUrl += (redirectUrl.includes("?") ? "&" : "?") + `tag=${affiliateTag}`;
      }
      
      console.log('Final Affiliate Link:', redirectUrl);
      
      // Open in a new tab with security best practices
      window.open(redirectUrl, "_blank", "noopener,noreferrer");
    } else {
      console.error('Invalid response format from buy-now API:', response.data);
      alert("Unable to generate a direct buy link. The product might be out of stock or unavailable.");
    }
  } catch (error) {
    console.error('Buy Now flow failed:', error);
    const errorMsg = error.response?.data?.error || "Failed to initiate purchase. Please try again later.";
    alert(errorMsg);
  }
};
